// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import './DiamondCut.style';

export class DiamondCut extends PureComponent {
    static propTypes = {
        product: this.propTypes,
        diamond_cut: this.propTypes
    };

    state = {
        activeCut: {}
    }

    cut = [
        {
            label: "Excellent",
            description: "Excellent: Maximum brilliance and fire. The ultimate choice for sparkle.",
            className: 'excellent',
            img: "/media/diamond-info-images/Diamond-Cut-Excellent.png"
        },
        {
            label: "Very Good",
            description: "Very Good: Slight variations in proportions. High brilliance with excellent value for money.",
            className: 'verygood',
            img: "/media/diamond-info-images/Diamond-Cut-VeryGood.png"
        },
        {
            label: "Good",
            description: "Good: Noticeable variations in light performance. A practical and affordable choice for everyday wear.",
            className: 'good',
            img: "/media/diamond-info-images/Diamond-Cut-Good.png"
        }
        // {
        //     label: "Fair",
        //     description: "Fair cut diamonds offers little brilliance, in this type of cut the light may easily appears on the sides and bottom. It fits adequately for small carats and as side stones.",
        //     className: 'fair'
        // },
        // {
        //     label: "Poor",
        //     description: "To emit a highest level of brilliance and fire, this ideal cut is superior choice. Because overall received light is reflected throughout the diamond.",
        //     className: 'poor'
        // }
    ];

    componentDidMount() {
        const { diamond_cut } = this.props;

        const cut = this.cut?.find((value) => (
            value?.label?.toLowerCase() === diamond_cut?.toLowerCase()
        ));

        this.setState({
            activeCut: cut ? cut : this.cut[0]
        });
    }

    changeDiamondInfo = (value) => {
        this.setState({
            activeCut: value
        });
    }

    render() {
        const {
            diamond_cut
        } = this.props;

        const { activeCut } = this.state;

        return (
            <>
                {/* {here is a chance of visibility to naked eye, more inclusions compared to SI1.
                    product[0].diamond_cut ? <div className="DiamondCut">
                        <div className='DiamondSize-container'>
                            <h2 className="diamond-size-title">Diamond Cut: <span>{product[0].diamond_cut}</span></h2>
                            <div className='size-content'>
                                <p>The diamond-cut mentioned with angles and proportions. The actual diamond-cut depends on how good the diamond is polished. Diamond cut does not defined with shape; it defines with depth and symmetry of it. The excellence of a diamond cut directly impacts the beauty of diamond. The perfection of a diamond cut is defined by its reflection and refraction towards the light.</p>
                            </div>

                            <div className="Diamond-cut-data-container">
                                <div className="diamond-cut-data">
                                    {
                                        this.cut.map((value, index) => (
                                            <div className={value.label === product[0].diamond_cut ? "item" : "item-hidden item"} key={index}>
                                                <div className="info">
                                                    <span className={`arrow ${value.className}_a`}></span>
                                                    <div className="titlehere is a chance of visibility to naked eye, more inclusions compared to SI1.">{product[0].diamond_cut}</div>
                                                    <p>{value.description}</p>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>

                            <div className='diamond-cut-chart'>
                                <div className='diamond-cut-item-container'>
                                    <div className={(product[0].diamond_cut === "Excellent" ? "diamond-cut-item_isActive " : "") + 'diamond-cut-item'}>
                                        <span>Excellent</span>
                                    </div>
                                    <div className={(product[0].diamond_cut === "Very Good" ? "diamond-cut-item_isActive " : "") + 'diamond-cut-item'}>
                                        <span>Very good</span>
                                    </div>
                                    <div className={(product[0].diamond_cut === "Good" ? "diamond-cut-item_isActive " : "") + 'diamond-cut-item'}>
                                        <span>Good</span>
                                    </div>
                                    <div className={(product[0].diamond_cut === "Fair" ? "diamond-cut-item_isActive " : "") + 'diamond-cut-item'}>
                                        <span>Fair</span>
                                    </div>
                                    <div className={(product[0].diamond_cut === "Poor" ? "diamond-cut-item_isActive " : "") + 'diamond-cut-item'}>
                                        <span>Poor</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : <></>
                } */}

                <div className='DiamondDetails-ContentSection'>
                    {/* <svg width="199" height="200" viewBox="0 0 199 200" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="mask0_2677_15248" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="199" height="200">
                            <rect x="0.208984" y="0.766602" width="198.62" height="198.62" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2677_15248)">
                            <path d="M142.183 33.6874L142.012 39.4584L147.095 36.721L142.183 33.6874ZM165.46 76.9143L165.892 77.1656L166.033 76.9237L165.9 76.6772L165.46 76.9143ZM144.188 113.498L144.278 113.99L144.504 113.949L144.62 113.75L144.188 113.498ZM71.1973 126.859H70.6973V127.459L71.2873 127.351L71.1973 126.859ZM143.876 37.8865L165.02 77.1514L165.9 76.6772L144.757 37.4124L143.876 37.8865ZM165.028 76.663L143.756 113.247L144.62 113.75L165.892 77.1656L165.028 76.663ZM144.098 113.007L71.1072 126.367L71.2873 127.351L144.278 113.99L144.098 113.007ZM71.6973 126.859V30.1367H70.6973V126.859H71.6973Z" fill="#800020" />
                            <path d="M99.517 150.016L179.056 86.1837L148.177 64.1475H50.8898L19.9785 86.1837L99.517 150.016Z" stroke="#181F37" strokeWidth="2" />
                        </g>
                    </svg> */}

                    <img src={activeCut?.img} />


                    <div className='DiamondDetails-ListOf'>
                        {
                            this.cut?.map((value, index) => (
                                <div className={'DiamondDetails-ListOf_item' + (value?.label?.toLowerCase() === activeCut?.label?.toLowerCase() ? " DiamondDetails-ListOf_item_active" : "")}
                                    key={index}
                                    onClick={() => this.changeDiamondInfo(value)}
                                >

                                    <span>{value?.label}</span>
                                </div>
                            ))
                        }
                    </div>

                    <div className='DiamondDetails-ListOfContent'>
                        <p>{this.state?.activeCut?.description}</p>
                    </div>
                </div>
            </>
        );
    }
}

export default DiamondCut;
